/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorVideoPlaylist as ResolvedLabradorVideoPlaylist } from 'base/components/labrador/VideoPlaylist';

export const LabradorVideoPlaylist: typeof ResolvedLabradorVideoPlaylist = withLabradorInstanceof((props) => {
    return <ResolvedLabradorVideoPlaylist {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorVideoPlaylistProps = PropsFromComponent<typeof LabradorVideoPlaylist>;
